<template>
  <section class="customers-add">
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <h2 class="subtitle">General Information</h2>
    <form @submit.prevent="submit">
      <div
        v-if="
          disableForm && !this.userExternalCheck() && !this.switchCustomerView
        "
      >
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Customer name">
              <b-input
                name="customer_name"
                :disabled="disableView"
                v-model="form.name"
                required
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Preferred communication language">
              <b-select
                name="communication_language"
                expanded
                :disabled="disableView"
                v-model="form.communication_language"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in customerLanguages"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Customer Short Name">
              <b-input
                name="name_short"
                :disabled="disableView"
                v-model="form.name_short"
                required
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Individual Message">
              <b-input
                name="custom_message"
                :disabled="disableView"
                v-model="form.custom_message"
              />
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="CRM ID">
              <template #label v-if="form.crm_guid">
                CRM ID
                <span @click.prevent="redirectToCRM(form.crm_guid)">
                  <b-icon size="is-small" icon="open-in-new"></b-icon>
                </span>
              </template>
              <b-input
                name="crm_id"
                :disabled="disableView"
                v-model="form.crm_id"
                placeholder="Unique ID"
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Customer Account Manager">
              <b-select
                name="account_manager"
                :disabled="disableAccountManager"
                v-model="form.account_manager_id"
                expanded
                placeholder="Please select"
                required
              >
                <option selected></option>
                <option
                  v-for="(option, index) in amUsers"
                  :value="option.id"
                  :key="index"
                  :disabled="option.is_active == false"
                  :hidden="option.is_active == false"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Merchant ID">
              <b-input
                name="merchant_id"
                :disabled="disableView"
                v-model="form.merchant_id"
                placeholder="Unique ID"
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Backup Customer Account Manager">
              <b-select
                name="backup_account_manager"
                :disabled="disableBackupAccountManager"
                v-model="form.backup_account_manager_id"
                expanded
                placeholder="Please select"
              >
                <option selected></option>
                <option
                  v-for="(option, index) in amUsers"
                  :value="option.id"
                  :key="index"
                  :disabled="option.is_active == false"
                  :hidden="option.is_active == false"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Address">
              <b-input
                name="customer_address"
                :disabled="disableView"
                v-model="form.address"
                required
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Reporting Responsible (optional)">
              <b-select
                name="reporting_responsible"
                :disabled="disableView"
                v-model="form.reporting_responsible_id"
                expanded
                placeholder="Please select"
              >
                <option selected></option>
                <option
                  v-for="(option, index) in rrUsers"
                  :value="option.id"
                  :key="index"
                  :disabled="option.is_active == false"
                  :hidden="option.is_active == false"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field
              name="data_delivery_deadline"
              :disabled="disableView"
              v-model="form.data_delivery_deadline"
              required
              label="Data Delivery Deadline (in days)"
            >
              <b-input
                v-model="form.data_delivery_deadline"
                :disabled="disableView"
                type="number"
                maxlength="30"
                required
              >
              </b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Sales Accountable">
              <b-select
                name="sales_accountable"
                :disabled="disableView"
                v-model="form.sales_accountable"
                expanded
                placeholder="Please select"
              >
                <option selected></option>
                <option
                  v-for="(option, index) in voUsers"
                  :value="option.id"
                  :key="index"
                  :disabled="option.is_active == false"
                  :hidden="option.is_active == false"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div
          class="columns no-margin-bottom"
          v-if="form.proof_of_submission == 3"
        >
          <div class="column">
            <b-field
              label="Selected countries"
              v-if="form.proof_of_submission == 3"
            >
              <b-taginput
                v-model="tags"
                :data="filteredTags"
                autocomplete
                field="name"
                icon="label"
                placeholder="Add a country"
                @typing="getFilteredTags"
                ellipsis
                :disabled="disableView"
              >
              </b-taginput>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Landbell Entity">
              <b-select
                name="landbell_entity"
                :disabled="disableView"
                v-model="form.landbell_entity"
                expanded
                placeholder="Please select"
              >
                <option
                  selected
                  v-for="(option, index) in landbellEntities"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Proof of Submission">
              <b-select
                name="proof_of_submission"
                expanded
                :disabled="disableView"
                v-model="form.proof_of_submission"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in proofOfSubmissionOptions"
                  :value="option.id"
                  :key="index"
                  :selected="proof_of_submission == 1"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Customer Type">
              <b-select
                name="customer_type"
                :disabled="disableView"
                v-model="form.customer_type"
                expanded
                placeholder="Please select"
              >
                <option
                  selected
                  v-for="(option, index) in customerType"
                  :value="option.value"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column" v-if="form.proof_of_submission != 3">
            <b-field label="Landbell Entity">
              <b-select
                name="landbell_entity"
                :disabled="disableView"
                v-model="form.landbell_entity"
                expanded
                placeholder="Please select"
              >
                <option
                  selected
                  v-for="(option, index) in landbellEntities"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field label="Raw Data Management in Circul8"></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="raw_datamanagement"
                    :disabled="disableView"
                    v-model="form.raw_data_management"
                  />
                </div>
              </div>
            </div>
            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field label="Enable Compliance Cost Dashboard"></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="compliance_cost_dashboard"
                    :disabled="disableView"
                    v-model="form.compliance_cost_dashboard"
                    @input="validateComplianceCostSettings"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field
                    label="Enable Compliance Cost Playgrounds"
                    style="margin-bottom: 0px;"
                  ></b-field>
                  <span
                    class="additional-info"
                    style="margin-left: 4px; display: inline-block; position: relative; top: -1px;"
                  >
                    <b-tooltip
                      type="is-primary"
                      :label="
                        `Please note that to enable the Playgrounds section, the Compliance Cost Dashboard section must be enabled first.`
                      "
                      multilined
                    >
                      <i class="mdi mdi-information"></i>
                    </b-tooltip>
                  </span>
                </div>
                <div class="level-right">
                  <b-switch
                    name="compliance_cost_playgrounds"
                    :disabled="disableView || !form.compliance_cost_dashboard"
                    v-model="form.compliance_cost_playground"
                    @input="validateComplianceCostSettings"
                  />
                </div>
              </div>
            </div> -->
            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field
                    label="Customer Approval of Reports created in C8"
                  ></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="customer_reportsapproval"
                    :disabled="disableView"
                    v-model="form.customer_reports_approval"
                  />
                </div>
              </div>
            </div>
            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field label="Customer Operational"></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="operational"
                    :disabled="disableView"
                    :checked="true"
                    v-model="form.operational"
                  />
                </div>
              </div>
            </div>
            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field
                    label="Generation of Reporting Categories Template for Reminders"
                  ></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="rc_template_for_reminders"
                    :disabled="disableView"
                    :checked="true"
                    v-model="form.rc_template_for_reminders"
                  />
                </div>
              </div>
            </div>

            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field label="The company has hierarchy"></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="company_hierarchy"
                    :disabled="disableView"
                    :checked="true"
                    v-model="form.company_hierarchy"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="column" v-else>
            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field label="Raw Data Management in Circul8"></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="customer_reportsapproval"
                    :disabled="disableView"
                    v-model="form.customer_reports_approval"
                  />
                </div>
              </div>
            </div>
            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field label="Enable Compliance Cost Dashboard"></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="compliance_cost_dashboard"
                    :disabled="disableView"
                    v-model="form.compliance_cost_dashboard"
                    @input="validateComplianceCostSettings"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field
                    label="Enable Compliance Cost Playgrounds"
                    style="margin-bottom: 0px;"
                  ></b-field>
                  <span class="additional-info">
                    <b-tooltip
                      type="is-primary"
                      :label="
                        `Please note that to enable the Playgrounds section, the Compliance Cost Dashboard section must be enabled first.`
                      "
                      multilined
                    >
                      <i class="mdi mdi-information"></i>
                    </b-tooltip>
                  </span>
                </div>
                <div class="level-right">
                  <b-switch
                    name="compliance_cost_playgrounds"
                    :disabled="disableView || !form.compliance_cost_dashboard"
                    v-model="form.compliance_cost_playground"
                    @input="validateComplianceCostSettings"
                  />
                </div>
              </div>
            </div> -->
            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field
                    label="Customer Approval of Reports created in C8"
                  ></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="raw_datamanagement"
                    :disabled="disableView"
                    v-model="form.raw_data_management"
                  />
                </div>
              </div>
            </div>
            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field label="Customer Operational"></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="operational"
                    :disabled="disableView"
                    :checked="true"
                    v-model="form.operational"
                  />
                </div>
              </div>
            </div>
            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field
                    label="Generation of Reporting Categories Template for Reminders"
                  ></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="rc_template_for_reminders"
                    :disabled="disableView"
                    :checked="true"
                    v-model="form.rc_template_for_reminders"
                  />
                </div>
              </div>
            </div>

            <div class="margin-bottom-normal">
              <div class="level">
                <div class="level-left">
                  <b-field label="The company has hierarchy"></b-field>
                </div>
                <div class="level-right">
                  <b-switch
                    name="company_hierarchy"
                    :disabled="disableView"
                    :checked="true"
                    v-model="form.company_hierarchy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="columns no-margin-bottom">
          <div class="column">
            <span class="customer-form-level">Customer Name: </span>
            <span class="enable-select-text">{{ form.name }}</span>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <span class="customer-form-level">Customer Address: </span>
            <span class="enable-select-text">{{
              form.address ? form.address : "NA"
            }}</span>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <span class="customer-form-level">Customer Account Manager: </span>
            <span class="enable-select-text">{{
              form.account_manager_name
            }}</span>
          </div>
        </div>
        <div class="columns customer-form-last-column">
          <div class="column" v-if="form.account_manager_email">
            <span class="customer-form-level"
              >Customer Account Manager Email:
            </span>
            <span class="enable-select-text">{{
              form.account_manager_email
            }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="form.company_hierarchy || entities.length > 0"
        class="enable-select-text"
      >
        <customer-entity
          :checkable="tableCheckable"
          :entity-action="disableView"
          :entities="entities"
          @confirm="entityConfirm"
          @deactivate="deactivateConfirm"
        ></customer-entity>
      </div>
      <hr />
      <div class="columns">
        <div class="column">
          <ul class="context-options-left">
            <li>
              <b-button
                v-if="this.isAction == 'Edit'"
                slot="right"
                @click="deactivateBtnAction"
                type="is-danger"
                class="deactivateBtn"
              >
                Deactivate
              </b-button>
            </li>
            <li>
              <b-button
                v-if="!disableView"
                slot="right"
                native-type="submit"
                type="is-primary"
                @click="confirm"
              >
                Save
              </b-button>
            </li>
          </ul>
        </div>
      </div>
    </form>
    <div
      class="is-fluid customer-profile-report-contact-credential enable-select-text"
      v-if="disable"
    >
      <b-tabs type="is-boxed">
        <b-tab-item
          data-cy="add-reports"
          label="Reports"
          v-if="!this.userExternalCheck() && !this.switchCustomerView"
          headerClass="reports"
        >
          <div class="level is-mobile no-margin">
            <div class="level-left">
              <a @click.prevent="exportCustomerReports">Export</a>
            </div>
            <div class="level-right">
              <div class="level-item">
                <b-button
                  type="is-primary"
                  icon-right="plus"
                  :disabled="disableView"
                  @click.prevent="addReportModal"
                />
                <customer-report-add
                  v-if="loadTabs"
                  :is-active="isModalActive"
                  :is-add="isAdd"
                  :action="action"
                  :edit-object-name="editObjectName"
                  :customer-id="Number(this.$route.params.id)"
                  @confirm="editReportConfirm"
                  @cancel="editReportCancel"
                />
              </div>
            </div>
          </div>
          <ClientReports
            v-if="loadTabs"
            :checkable="tableCheckable"
            :contact-action="disableView"
            :customer-account-manager="form.account_manager_id"
            :backup-customer-account-manager="form.backup_account_manager_id"
            :countryMaps="countryMap"
          ></ClientReports>
        </b-tab-item>
        <b-tab-item label="Scope" data-cy="scope" headerClass="scope">
          <div class="level is-mobile">
            <div class="level-left">
              <div class="level-item">
                <label class="label"> Countries, Streams &amp; Schemes </label>
                <span slot="trigger" class="navbar-item scope-export-link">
                  <a @click="exportScopes" data-cy="scope-export">Export</a>
                </span>
              </div>
            </div>
          </div>
          <div class="scopes is-mobile">
            <div
              class="columns"
              v-for="(scope, index) in scopes"
              :key="'scope-' + index"
            >
              <div class="column" :key="'scope-country-' + index">
                {{ scope.country_of_activity }}
              </div>
              <div class="column" :key="'scope-streams-' + index">
                {{ scope.stream_in_scope }}
              </div>
              <div class="column" :key="'scope-scheme-' + index">
                {{ scope.scheme_in_scope }}
              </div>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item
          data-cy="contact-information"
          label="Contact Information"
          headerClass="contact-information"
          ><contact-information
            v-if="loadTabs"
            :checkable="tableCheckable"
            :contact-action="disableView"
          ></contact-information>
        </b-tab-item>
        <b-tab-item
          data-cy="registration-number"
          label="Registration Numbers"
          headerClass="registration-numbers"
          ><registration-number
            v-if="loadTabs"
            :checkable="tableCheckable"
            :login-action="disableView"
            :customer-account-manager="form.account_manager_id"
            :backup-customer-account-manager="form.backup_account_manager_id"
          ></registration-number>
        </b-tab-item>
        <b-tab-item
          label="Client Credentials"
          headerClass="client-credentials"
          v-if="
            !this.userExternalCheck() &&
              !this.switchCustomerView &&
              !isViewOnlyUser
          "
        >
          <div v-if="!disableViewOnlyUsers">
            <client-credentials
              v-if="loadTabs"
              :checkable="tableCheckable"
              :login-action="disableView"
              :customer-account-manager="form.account_manager_id"
              :backup-customer-account-manager="form.backup_account_manager_id"
            ></client-credentials>
          </div>
        </b-tab-item>
        <b-tab-item
          label="Communication"
          headerClass="communication"
          v-if="this.switchCustomerView || this.userExternalCheck()"
        >
          <div v-if="!disableViewOnlyUsers">
            <communication
              v-if="loadTabs"
              :checkable="tableCheckable"
              :login-action="disableView"
              :customer-account-manager="form.account_manager_id"
              :backup-customer-account-manager="form.backup_account_manager_id"
            ></communication>
          </div>
        </b-tab-item>
        <b-tab-item
          data-cy="reporting_category "
          label="Reporting Categories"
          headerClass="reporting_category"
          ><reporting-category
            v-if="loadTabs"
            :checkable="tableCheckable"
            :disabled="disableView"
            :customer-account-manager="form.account_manager_id"
            :backup-customer-account-manager="form.backup_account_manager_id"
          ></reporting-category>
        </b-tab-item>
        <b-tab-item
          label="Customer Specific Prices"
          headerClass="customer-specific-prices"
          v-if="
            !this.userExternalCheck() &&
              !this.switchCustomerView &&
              !isViewOnlyUser
          "
        >
          <div v-if="!disableViewOnlyUsers">
            <customer-specific-prices
              v-if="loadTabs"
              :checkable="tableCheckable"
              :login-action="disableView"
              :customer-account-manager="form.account_manager_id"
              :backup-customer-account-manager="form.backup_account_manager_id"
            ></customer-specific-prices>
          </div>
        </b-tab-item>
        <b-tab-item
          label="CDF PD Template"
          headerClass="CDF-PD-template"
          v-if="!this.userExternalCheck() && !this.switchCustomerView"
        >
          <CDF-product-data
            v-if="loadTabs"
            :checkable="tableCheckable"
            :cdfAction="disableView"
            :customer-account-manager="form.account_manager_id"
            :backup-customer-account-manager="form.backup_account_manager_id"
          ></CDF-product-data>
        </b-tab-item>
        <b-tab-item
          label="CDF TD Template"
          headerClass="CDF-TD-template"
          v-if="!this.userExternalCheck() && !this.switchCustomerView"
        >
          <CDF-transaction-data
            v-if="loadTabs"
            :checkable="tableCheckable"
            :cdfAction="disableView"
            :customer-account-manager="form.account_manager_id"
            :backup-customer-account-manager="form.backup_account_manager_id"
          ></CDF-transaction-data>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>
<script>
import ClientCredentials from "@/components/Customers/ClientCredentials";
import ReportingCategory from "@/components/Customers/ReportingCategory.vue";
import CustomerSpecificPrices from "@/components/Customers/CustomerSpecificPrices";
import ContactInformation from "@/components/Customers/ContactInformation";
import CDFProductData from "@/components/Customers/CDFProductData.vue";
import CDFTransactionData from "@/components/Customers/CDFTransactionData.vue";
import ClientReports from "@/components/Customers/ClientReports";
import CustomerEntity from "@/components/Customers/CustomerEntity";
import CustomerReportAdd from "@/components/Customers/CustomerReportAdd";
import RegistrationNumber from "@/components/Customers/RegistrationNumbers";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import UserDataService from "../../services/UserDataService";
import CountryDataService from "../../services/CountryDataService";
import ContainerDataService from "../../services/ContainerDataService";
import SchemeDataService from "../../services/SchemeDataService";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import { Permission } from "../../services/Permissions";
import { UserGroup } from "@/services/UserGroups";
import { AuthService } from "@/services/AuthService";
import { mapGetters } from "vuex";
import Communication from "@/components/Customers/CommunicationList.vue";
import CustomerReportService from "@/services/CustomerReportService";
// @group Customers
export default {
  name: "CustomerAddViewComponent",
  mixins: [UserPermissionMixin, UtilityMixin, ScopeMixin],
  props: {
    isAction: {
      type: String,
      default: null
    }
  },
  components: {
    ClientCredentials,
    ContactInformation,
    CustomerEntity,
    CustomerReportAdd,
    ClientReports,
    CDFProductData,
    CDFTransactionData,
    RegistrationNumber,
    CustomerSpecificPrices,
    ReportingCategory,
    Communication
  },
  data() {
    return {
      filteredTags: this.countries,
      isSelectOnly: false,
      form: this.getClearFormObject(),
      authService: new AuthService(),
      customerDataService: new CustomerProfileDataService(),
      userDataService: new UserDataService(),
      containerDataService: new ContainerDataService(),
      countryDataService: new CountryDataService(),
      schemeDataService: new SchemeDataService(),
      customerReportService: new CustomerReportService(),
      country: ["Austria", "Germany"],
      countryMap: {},
      containerMap: {},
      schemes: [],
      schemeMap: {},
      users: [],
      rrUsers: [],
      amUsers: [],
      voUsers: [],
      userMap: {},
      stream: ["Packaging", "WEEE"],
      landbellEntities: [
        " ",
        "H2C",
        "SAS",
        "LB",
        "UK",
        "Topengi",
        "Amazon Marketplace",
        "General Marketplace",
        "ERP UK"
      ],
      customerType: [
        { value: null, name: "" },
        { value: "Small Customer", name: "Small Customer" },
        {
          value: "Small - EuropePlus Customer",
          name: "Small - EuropePlus Customer"
        },
        {
          value: "Small - Flat Rate Customer",
          name: "Small - Flat Rate Customer"
        },
        { value: "Large Customer", name: "Large Customer" }
      ],
      reports: [],
      reportIdList: [],
      scopes: [],
      scopeIdList: [],
      data: [],
      entities: [],
      entityObject: {},
      customerLanguages: [],
      hasAccessToCustomer: false,
      loadTabs: false,
      proofOfSubmissionOptions: [
        {
          id: 1,
          name: "Optional for all countries"
        },
        {
          id: 2,
          name: "Mandatory for all countries"
        },
        {
          id: 3,
          name: "Select Countries"
        }
      ],

      isLoading: false,
      isModalActive: false,
      isAdd: false,
      action: null,
      editObject: this.getClearFormObject(),
      isScopeModalActive: false,
      isScopeAdd: false,
      scopeAction: null,
      editScopeObject: this.getClearFormObject(),
      tableCheckable: true,
      selectDisable: true,
      rowIndex: -1,
      proof_of_submission: 1,
      tags: []
    };
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "switchCustomerView"
    ]),
    disableViewOnlyUsers() {
      if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
        return true;
      }
      return false;
    },
    isViewOnlyUser() {
      if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
        return true;
      }
      return false;
    },
    disableForm() {
      if (this.isAction == "Add" || this.isAction == "Edit") {
        return (
          this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
          this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM)
        );
      }
      return true;
    },
    disableBackupAccountManager() {
      if (this.isAction == "View") {
        return true;
      } else if (this.isAction == "Edit") {
        if (
          this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
          this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
        ) {
          return false;
        } else if (
          this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) &&
          (this.form.account_manager_id == this.userId ||
            this.form.backup_account_manager_id == this.userId)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    disableAccountManager() {
      if (this.isAction == "View") {
        return true;
      } else if (this.isAction == "Edit" || this.isAction == "Add") {
        if (this.userGroups.includes(UserGroup.EPR_ADMIN)) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    disable() {
      if (this.isAction == "Edit" || this.isAction == "View") {
        return true;
      }
      return false;
    },
    disableView() {
      if (this.isAction == "View") {
        return true;
      }
      return false;
    },
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    editScopeObjectName() {
      return this.editScopeObject || this.getClearFormObject();
    }
  },
  watch: {
    users(newValue) {
      this.prepareUserData(newValue);
      this.getCustomerById();
      this.fetchCustomerReports();

      // Auto-set the account_manager_id to the current user if they are a Customer Account Manager
      // when creating a new customer and user data is loaded
      if (
        this.isAction == "Add" &&
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        this.form.account_manager_id = this.userId;
      }
    },
    // Watch for changes to compliance_cost_dashboard and disable playground if needed
    "form.compliance_cost_dashboard": function(newValue) {
      // If dashboard is disabled, ensure playground is also disabled
      if (!newValue && this.form.compliance_cost_playground) {
        this.form.compliance_cost_playground = false;
      }
    }
  },
  mounted() {
    if (this.isAction != "Add") {
      this.isLoading = true;
    }

    //only allow Admin and CAM to edit the customer info
    // Below code block is used to restrict user if that user tries to change URL directory to edit any other customer information
    if (
      this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
      this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) ||
      this.isAction == "View"
    ) {
      this.hasAccessToCustomer = true;
    } else {
      this.$router.push({ name: "home" });
    }
    // Auto-set the account_manager_id to the current user if they are a Customer Account Manager
    if (
      this.isAction == "Add" &&
      this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
    ) {
      this.form.account_manager_id = this.userName;
    }

    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    this.fetchLanguages();
    this.fetchUserData();
    this.disableTableCheckProperty();
    this.disableSelectProperty();
  },
  methods: {
    redirectToCRM(url) {
      window.open(url, "_blank");
    },
    exportScopes() {
      try {
        this.customerDataService.exportCustomerScope(this.$route.params.id);
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error in Export",
          message: e.message
        });
      }
    },
    deactivateBtnAction() {
      this.$buefy.dialog.confirm({
        title: "Confirmation",
        confirmText: "Yes",
        type: "is-danger",
        message:
          "Do you really want to deactivate this customer? All future report trackers will be deleted",
        onConfirm: () => this.deactivateCustomer()
      });
      return 1;
    },
    getFilteredTags(text) {
      this.filteredTags = this.countries.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        );
      });
    },

    getCustomerById() {
      if (this.$route.params.id) {
        this.customerDataService
          .getCustomerById(this.$route.params.id)
          .subscribe(
            response => {
              this.isLoading = false;
              this.loadTabs = true;
              this.form = response;
              this.tags = response.proof_of_submission_countries;
              this.form.reporting_responsible_id =
                response.reporting_responsible;
              this.form.account_manager_id = response.account_manager;
              this.form.backup_account_manager_id =
                response.backup_account_manager;
              this.form.account_manager_name = this.users.filter(
                user => user.id == response.account_manager
              )[0].name;
              // check if the user is in CAM  group
              // check if the user is CAM to customer
              if (
                !this.userHasPermission(
                  Permission.RTRACKER_REPORT_ASSIGN_ALL
                ) &&
                this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM)
              ) {
                if (
                  this.form.account_manager_id == this.userId ||
                  this.form.backup_account_manager_id == this.userId ||
                  this.isAction == "View"
                ) {
                  this.hasAccessToCustomer = true;
                } else {
                  this.hasAccessToCustomer = false;
                }
              }

              if (!this.hasAccessToCustomer) {
                this.$router.push({ name: "home" });
              }

              this.prepareScopeAndEntityData(response);
            },
            e => {
              console.log(e);
              this.$buefy.toast.open({
                message: e.response["data"].detail,
                type: "is-danger"
              });
              this.$router.push({ name: "home" });
              this.isLoading = false;
            }
          );
      }
    },
    disableSelectProperty() {
      if (this.isAction == "View") {
        this.selectDisable = false;
      }
    },
    disableTableCheckProperty() {
      if (this.isAction == "View") {
        this.tableCheckable = false;
      }
    },
    prepareCustomerScope(dataList) {
      const scopeDataList = [];
      const scopeIdDataList = [];
      const newDict = {};
      for (const index in dataList) {
        const data = dataList[index];
        const key = data["country_of_activity__name"];
        if (key in newDict) {
          const streamLst = newDict[key]["streams"];
          streamLst.push(data["stream_in_scope__name"]);
          const schemeList = newDict[key]["schemes"];
          schemeList.push(data["scheme_in_scope__name"]);
          newDict[key] = { streams: streamLst, schemes: schemeList };
        } else {
          newDict[key] = {
            streams: [data["stream_in_scope__name"]],
            schemes: [data["scheme_in_scope__name"]]
          };
        }
      }

      for (const key in newDict) {
        let streams = "";
        const streamlist = [];
        const streamData = newDict[key]["streams"];
        for (const idx in streamData) {
          const value = streamData[idx];
          if (!streams.includes(value)) {
            streams = this.joinStrings(streams, value, ",");
            streamlist.push(streamData[idx]);
          }
        }

        let schemes = "";
        const schemelist = [];
        const schemeData = newDict[key]["schemes"];
        for (const idx in schemeData) {
          const value = schemeData[idx];
          if (!schemes.includes(value)) {
            schemes = this.joinStrings(schemes, value, ",");
            schemelist.push(schemeData[idx]);
          }
        }

        const scopeData = {
          country_of_activity: key,
          stream_in_scope: streams,
          scheme_in_scope: schemes
        };
        scopeDataList.push(scopeData);
        const scopeIdData = {
          country_of_activity: key,
          stream_in_scope: streamlist,
          scheme_in_scope: schemelist
        };
        scopeIdDataList.push(scopeIdData);
      }

      this.scopes = scopeDataList;
      this.scopeIdList = scopeIdDataList;
    },
    prepareCustomerEntity(dataList) {
      const entityData = [];
      for (const index in dataList) {
        const data = dataList[index];
        data["entity_country_id"] = data["entity_country"];
        data["entity_country"] = this.countryMap[data["entity_country_id"]];
        data["actions"] = true;
        entityData.push(data);
      }
      this.entities = entityData;
    },
    prepareScopeAndEntityData(r) {
      this.prepareCustomerScope(r.scope);
      this.prepareCustomerEntity(r.entities);
    },
    getData() {
      if (this.$route.params.id) {
        if (this.$route.params.row) {
          this.form = this.$route.params.row;
          this.prepareScopeAndEntityData();
        } else {
          this.$buefy.toast.open({
            message: `Error: ${"Record does not exist, refresh and try again"}`,
            type: "is-danger",
            queue: false
          });
        }
      }
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    fetchLanguages() {
      this.customerDataService.getLanguages().subscribe(
        response => {
          this.customerLanguages = response;
        },
        e => {
          console.log(e);
          this.isLoading = false;
        }
      );
    },
    filterUsers(users, role) {
      const newUsers = [];
      for (const user of users) {
        const epradmin = user.groups.filter(e => e.name === role);
        if (epradmin.length > 0) {
          newUsers.push(user);
        }
      }
      return newUsers;
    },
    prepareUserData() {
      this.rrUsers = this.filterUsers(this.users, "Reporting Responsible");
      this.amUsers = this.filterUsers(this.users, "Customer Account Manager");
      this.voUsers = this.filterUsers(this.users, "View Only");
    },

    fetchCustomerReports() {
      const reportsObserve = this.customerDataService.getCustomerReports(
        this.$route.params.id
      );
      reportsObserve.subscribe(
        response => {
          this.prepareCustomerReports(response);
        },
        e => {
          console.log(e);
        }
      );
      return reportsObserve;
    },
    prepareCustomerReports(dataList) {
      const reportDataList = [];
      for (const index in dataList) {
        const data = dataList[index];
        data["valid_from"] = this.convertToDate(data["valid_from"]);
        data["valid_to"] = this.convertToDate(data["valid_to"]);
        if (data["valid_from"] == null && data["valid_to"] == "2099-12-31") {
          data["valid_to"] = null;
        }

        data["scheme"] = this.schemes.filter(
          obj => obj.id == data["scheme"]
        )[0].name;
        data["country"] = this.countries.filter(
          obj => obj.id == data["country"]
        )[0].name;
        data["stream"] = this.containers.filter(
          obj => obj.id == data["stream"]
        )[0].name;
        data["valid_to"] = this.dateFormating(data["valid_from"]);
        data["valid_from"] = this.dateFormating(data["valid_from"]);
        reportDataList.push(data);
      }
      this.reports = reportDataList;
      this.data = reportDataList;
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    },
    dateFormating(dt) {
      let newDate = " - ";
      if (dt == null) {
        return newDate;
      }
      dt = new Date(dt);
      newDate =
        dt.getFullYear() +
        "-" +
        ("0" + (dt.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + dt.getDate()).slice(-2);
      return newDate;
    },
    addReportModal() {
      this.isAdd = false;
      this.action = "Add";
      this.editObject = this.getClearFormReportObject();
      this.isModalActive = true;
    },
    editReportModal(index) {
      this.isAdd = true;
      this.action = "Edit";
      this.editObject = this.reports[index];
      this.isModalActive = true;
    },
    deleteReportModal(index) {
      this.isAdd = true;
      this.action = "Delete";
      this.editObject = this.reports[index];
      this.isModalActive = true;
    },
    addScopeModal() {
      this.isScopeAdd = false;
      this.scopeAction = "Add";
      this.editScopeObject = this.getClearFormObject();
      this.isScopeModalActive = true;
    },
    editScopeModal(index) {
      this.isScopeAdd = false;
      this.scopeAction = "Edit";
      this.editScopeObject = this.scopeIdList[index];
      this.isScopeModalActive = true;
      this.rowIndex = index;
    },
    deleteScopeModal(index) {
      this.scopes.splice(index, 1);
      this.scopeIdList.splice(index, 1);
    },
    getClearFormReportObject() {
      return {
        id: null,
        customer: Number(this.$route.params.id),
        country: null,
        scheme: null,
        stream: null,
        report: null,
        valid_from: null,
        valid_to: null,
        frequency: null,
        additional_info: null
      };
    },
    getClearFormObject() {
      return {
        id: null,
        crm_id: null,
        crm_guid: null,
        merchant_id: null,
        name: null,
        name_short: null,
        address: null,
        company_hierarchy: false,
        communication_language: null,
        raw_data_management: false,
        compliance_cost_dashboard: false,
        compliance_cost_playground: false,
        reporting_responsible: null,
        account_manager: null,
        backup_account_manager: null,
        data_delivery_deadline: null,
        custom_message: null,
        stream_in_scope: [],
        proof_of_submission: 1,
        operational: null,
        rc_template_for_reminders: null,
        landbellEntities: null,
        landbell_entity: null
      };
    },
    isValidate() {
      if (
        this.form.name &&
        this.form.name_short &&
        this.form.address &&
        this.form.data_delivery_deadline > -1
      ) {
        return true;
      }
      return false;
    },
    submit() {
      if (this.isValidate()) {
        if (this.isAction == "Edit") {
          this.updateCustomer();
        } else {
          this.createCustomer();
        }
      }
    },
    populateResponseData(customer) {
      let countriesOfActivities = "";
      const scope = customer["scope"];
      customer["scopeIdList"] = customer["scope"];
      const countryList = [];
      for (const index in scope) {
        const country_id = scope[index]["country_of_activity"];
        if (!countryList.includes(country_id)) {
          countriesOfActivities = this.joinStrings(
            countriesOfActivities,
            this.countryMap[country_id],
            ","
          );
          countryList.push(country_id);
        }
      }
      customer["countries_of_activities"] = countriesOfActivities;
      customer["proof_of_submission_countries"] = this.tags;
      customer["account_manager_id"] = customer["account_manager"];
      customer["backup_account_manager_id"] =
        customer["backup_account_manager"];
      customer["reporting_responsible_id"] = customer["reporting_responsible"];
      customer["account_manager"] = this.userMap[customer["account_manager"]];
      customer["backup_account_manager"] = this.userMap[
        customer["backup_account_manager"]
      ];
      customer["reporting_responsible"] = this.userMap[
        customer["reporting_responsible"]
      ];
      this.form = customer;
      this.prepareScopeAndEntityData(this.form);
    },
    routeToCustomerList() {
      this.$router.push({ name: "customers" });
    },
    routeToCustomerEdit(customerId) {
      this.$router.push({
        name: "customers.edit",
        params: { id: customerId }
      });
      this.$emit("changeAction", "Edit");
      this.$route.params.id = customerId;
    },
    createCustomer() {
      this.isLoading = true;
      this.form.proof_of_submission_countries = this.tags;
      this.customerDataService
        .create(this.form, this.entities)
        .subscribe(response => {
          this.populateResponseData(response);
          this.isLoading = false;
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Customer Created!",
            onConfirm: () => this.routeToCustomerList()
          });
        }, this.handleApiError);
    },
    deactivateCustomer() {
      this.customerDataService
        .deactivate(this.$route.params.id)
        .subscribe(() => {
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Customer gets Deactivated!",
            onConfirm: this.routeToCustomerList()
          });
        }, this.handleApiError);
    },
    deactivateCustomerEntities(entities) {
      this.customerDataService.deactivateEntity(entities).subscribe(() => {
        this.$buefy.dialog.alert({
          title: "Success",
          message: "Customer Entity Deactivated successfully!",
          onConfirm: this.$router.go(0)
        });
      }, this.handleApiError);
    },
    updateCustomer() {
      this.isLoading = true;
      this.form.proof_of_submission_countries = this.tags;
      this.customerDataService
        .update(this.form, this.entities)
        .subscribe(response => {
          this.populateResponseData(response);
          this.isLoading = false;
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Customer Updated!"
            //onConfirm: () => this.routeToCustomerList()
          });
        }, this.handleApiError);
    },
    validateComplianceCostSettings() {
      // If dashboard is disabled, ensure playground is also disabled
      if (!this.form.compliance_cost_dashboard) {
        // Reset playgrounds toggle if dashboard is disabled
        if (this.form.compliance_cost_playground) {
          this.$buefy.toast.open({
            duration: 6000,
            message:
              "Error: To enable the Playgrounds section, the Compliance Cost Dashboard section must be enabled first.",
            position: "is-bottom",
            type: "is-danger"
          });
          // Reset playgrounds toggle
          this.form.compliance_cost_playground = false;
        }
      }
    },
    handleApiError(reason) {
      let errorMessage = undefined;
      let errCol = undefined;
      if (
        reason.response.status == 403 &&
        reason.response.data.code == "token_not_valid"
      ) {
        alert("Session expired, please login again");
        this.authService.logout(this.$keycloak);
        return;
      }
      try {
        errorMessage = reason.response.data["detail"];
      } catch (error) {
        errorMessage = reason.response.data["name"][0];
      } finally {
        errorMessage = reason.response.data["detail"];
        if (errorMessage == null || errorMessage == undefined) {
          const errReason = reason.response.data;
          errCol = Object.keys(errReason);
          errorMessage = errReason[errCol[0]];
          if (errorMessage == null || errorMessage == undefined) {
            errorMessage = "Invalid input";
          }
        }
        errorMessage = errCol ? errCol + ":  " + errorMessage : errorMessage;
        this.$buefy.dialog.alert({
          title: "Error",
          message: errorMessage,
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        this.isLoading = false;
      }
      return -1;
    },
    editScopeCancel() {
      this.isScopeModalActive = false;
    },
    editReportCancel() {
      this.isModalActive = false;
    },
    editReportConfirm() {
      this.getCustomerById();
      this.fetchCustomerReports();
      this.isModalActive = false;
      this.$router.go();

      // location.reload()
    },
    joinStrings(string1, string2, separator) {
      return string1 + (string1 === "" ? "" : separator + " ") + string2;
    },
    entityConfirm(data) {
      this.entities = data;
    },
    confirm() {
      this.isValidate();
    },
    deactivateConfirm(entities) {
      this.$buefy.dialog.confirm({
        title: "Confirmation",
        confirmText: "Yes",
        type: "is-danger",
        message:
          "Do you really want to deactivate this entities? All future report trackers will be deleted",
        onConfirm: () => this.deactivateCustomerEntities(Array.from(entities))
      });
    },
    editScopeConfirm(data) {
      this.isScopeModalActive = false;
      const streamData = data["stream_in_scope"].splice(0);
      let streams = "";
      const streamlist = [];
      for (const index in streamData) {
        streams = this.joinStrings(
          streams,
          this.containerMap[streamData[index]],
          ","
        );
        streamlist.push(streamData[index]);
      }
      const scopeData = {
        country_of_activity: this.countryMap[data["country_of_activity"]],
        stream_in_scope: streams
      };
      data["stream_in_scope"] = streamlist;
      if (data.rowIndex >= 0) {
        this.scopes[data.rowIndex] = scopeData;
        this.scopeIdList[data.rowIndex] = data;
      } else {
        data.rowIndex = this.scopeIdList.length;
        this.scopes.push(scopeData);
        this.scopeIdList.push(data);
      }

      this.$buefy.snackbar.open({
        message: "Scope added",
        queue: false
      });
    },
    exportCustomerReports() {
      try {
        this.customerReportService.export(this.$route.params.id);
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Export Error !!!",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    }
  }
};
</script>
